import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchMaintenanceRequests,
  createMaintenanceRequest,
  fetchMaintenanceRequest,
  updateMaintenanceRequest,
  assignMaintenanceRequest,
  type ListMaintenanceQuery,
  type CreateMaintenancePayload,
  type UpdateMaintenancePayload,
  type AssignMaintenancePayload,
} from '@/services/api/maintenance.api';

export function useMaintenanceRequests(query?: ListMaintenanceQuery) {
  return useQuery({
    queryKey: ['maintenance', query],
    queryFn: () => fetchMaintenanceRequests(query),
    staleTime: 30_000,
  });
}

export function useMaintenanceRequest(id: string | null) {
  return useQuery({
    queryKey: ['maintenance', id],
    queryFn: () => fetchMaintenanceRequest(id as string),
    staleTime: 30_000,
    enabled: id !== null,
  });
}

export function useCreateMaintenance() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateMaintenancePayload) => createMaintenanceRequest(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['maintenance'] });
    },
  });
}

export function useUpdateMaintenance() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateMaintenancePayload }) =>
      updateMaintenanceRequest(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['maintenance'] });
    },
  });
}

export function useAssignMaintenance() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: AssignMaintenancePayload }) =>
      assignMaintenanceRequest(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['maintenance'] });
    },
  });
}
